import { render, staticRenderFns } from "./StaffUpdateForm.vue?vue&type=template&id=ddf14c78&scoped=true&"
import script from "./StaffUpdateForm.vue?vue&type=script&lang=js&"
export * from "./StaffUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf14c78",
  null
  
)

export default component.exports